import { Navigate } from "react-router";
import { AppRouteGuard } from "../types";
import { authClient } from "../../auth/client";
import { SquareBackground } from "@repo/dashboard-components";

export const UnauthenticatedRouteGuard: AppRouteGuard = (props) => {
  const session = authClient.useSession();

  if (session.isPending || session.isRefetching) {
    return <SquareBackground mode="loading" />;
  }

  if (session.data) {
    return <Navigate to="/" />;
  }

  return props.children;
};
